import httpClient from "@plugins/http";
import appConfigs from "@configs/app";
import { cookieManager } from "@utils/cookie.manager";
import { ApiResponse } from "@apis/api.ts";
import { GoogleClientCredential, UserCredentialRequestParams } from "@plugins/google/types.ts";

const fetchCredential = (params: UserCredentialRequestParams) => {
  const token = cookieManager.getCookie("jwt_token");

  if (!token) {
    throw new Error("Access Denied: No jwt token found");
  }

  return httpClient.get(`${appConfigs.slsApiEndpoint}/google/user-credential/get`, {
    params: params,
    headers: { Authorization: `Bearer ${token}` },
  });
};

const refreshCredential = () => {
  const token = cookieManager.getCookie("jwt_token");

  if (!token) {
    throw new Error("Access Denied: No jwt token found");
  }

  return httpClient.post(
    `${appConfigs.slsApiEndpoint}/google/user-credential/refresh`,
    {},
    { headers: { Authorization: `Bearer ${token}` } },
  );
};

const linkAccount = (authCode) => {
  const token = cookieManager.getCookie("jwt_token");

  if (!token) {
    throw new Error("Access Denied: No jwt token found");
  }

  const payload = { authCode: authCode };
  return httpClient.post(`${appConfigs.slsApiEndpoint}/google/user-credential/link`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

const unlinkAccount = async () => {
  const token = cookieManager.getCookie("jwt_token");

  if (!token) {
    throw new Error("Access Denied: No jwt token found");
  }

  return await httpClient.post(
    `${appConfigs.slsApiEndpoint}/google/user-credential/unlink`,
    {},
    { headers: { Authorization: `Bearer ${token}` } },
  );
};
// TODO: [Google] inconsistent naming, standardize it
// TODO: [Google] unlikely this will change, cache in js, only fetch once unless page refresh
const getGoogleClientCredential = async (): Promise<ApiResponse<GoogleClientCredential>> => {
  return httpClient.get(`/apis/google-client-credential/get`);
};

export default {
  fetchCredential,
  refreshCredential,
  linkAccount,
  unlinkAccount,
  getGoogleClientCredential,
};
